registerComponent("blocks/slider-controls", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Este bloco não tem comportamento próprio — em 2020 também não tinha (o
 * arquivo era um `$(component)` comentado): quem preenchia `.slider-dots` e
 * ligava `.slick-prev`/`.slick-next` era o slick, chamado pelo componente PAI
 * (`appendDots`, `prevArrow`, `nextArrow`). Continua assim, com `Asa.trilho`
 * no lugar do slick (sub-lote 5d): o pai faz
 *
 *   Asa.trilho(lista, Asa.controlesDoTrilho(
 *       component.querySelector('[data-component-name="blocks/slider-controls"]')
 *   ));
 *
 * e o trilho escreve aqui o `ul.slick-dots > li > button` (com `li.slick-active`
 * no ativo e `aria-current` no botão) e `.slick-disabled`/`aria-disabled` nas
 * setas. `.slick-prev`, `.slick-next` e `.slider-dots` são classes de MARKUP
 * deste Blade, não de DOM gerado — ficam.
 */

});
